import {camelCase, get, isEmpty, isNull, reduce, split} from 'lodash';

/**
 * Returns Object containing Sitecore fields
 *
 * @param {*} props Sitecore Link Field JSON response
 *
 * @returns {object} Containing JSON for Sitecore fields
 */
export const extractFieldsFn = (props) =>
  get(props, 'rendering.fields');


export const getAppDomain = (appEnv, siteName) => {
  if (appEnv === 'prod')
    return `https://${siteName}.massmutual.com`;
  else if (appEnv === 'preview')
    return `https://${siteName}2.massmutual.com`;
  else if (appEnv === 'qa') 
    return `https://${siteName}-qa.massmutual.com`;
  else
    return `https://${siteName}-dev.massmutual.com`; 
};

